import React, { useEffect, useState } from "react";
import { Download, History } from "lucide-react";
import { practiceApi, openDocumentFile } from "../../lib/practiceApi";
import { usePager } from "../../lib/usePager";
import { Pager } from "../table/Pager";

export const QuoteDocumentHistory = ({ quoteId, refreshKey, onOpen }) => {
  const [documents, setDocuments] = useState([]);
  const [revisions, setRevisions] = useState([]);
  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);
  const pager = usePager(documents, 5);
  useEffect(() => {
    let active = true;
    Promise.all([practiceApi(`/estimates/${quoteId}/document-versions`), practiceApi(`/estimates/${quoteId}/document-revisions`)])
      .then(([docs, revs]) => { if (active) { setDocuments(docs); setRevisions(revs); setError(""); } })
      .catch(err => { if (active) setError(err.message); });
    return () => { active = false; };
  }, [quoteId, refreshKey]);
  return <section className="quote-document-history" data-testid="quote-document-history">
    <button className="ghost" data-testid="quote-history-toggle" onClick={() => setOpen(!open)}><History size={15} />Revisioni e documenti conservati</button>
    {open && <>
      <div className="practice-inline-actions">{revisions.map(rev => <button key={rev.id} className="ghost" disabled={rev.id === quoteId} data-testid={`quote-history-revision-${rev.id}`} onClick={() => onOpen(rev.id)}>{`Rev. ${rev.document_revision || 0} · ${rev.status}`}</button>)}</div>
      {pager.visible.map(doc => <div className="quote-history-document" key={doc.id} data-testid={`quote-history-document-${doc.id}`}>
        <span>{`${doc.kind === "letter" ? "Lettera d’incarico" : "Preventivo"} · ${doc.format.toUpperCase()} · ${doc.created_at.slice(0, 10)}`}</span>
        <button className="ghost" data-testid={`quote-history-download-${doc.id}`} title="Scarica copia conservata" onClick={() => openDocumentFile(`/estimates/${quoteId}/document-versions/${doc.id}`, `${doc.kind}-rev-${doc.revision}.${doc.format}`, doc.format).catch(err => setError(err.message))}><Download size={14} />Scarica</button>
      </div>)}
      <Pager pager={pager} label="documenti" testId="quote-history-pager" />
      {!documents.length && <p className="muted" data-testid="quote-history-empty">Nessun documento generato archiviato per questa revisione.</p>}
    </>}
    {error && <p className="error" role="alert" data-testid="quote-history-error">{error}</p>}
  </section>;
};